import React, { useEffect, useRef, useState } from "react";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import { Box, Container } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import { vehicleBreadcrumbD } from "../VehicleTrim/CreateVehicleTrim/constant";
import { printTableData } from "../../../utils/printUtils";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const VehicleDealerships = (props) => {
  const classes = useStyles();
  const {
    fetchVehicleDealershipss,
    tableData,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    exportVehicleDealerships,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateVehicleDealerships,
    editVehicleDealershipsRoute,
    deleteVehicleDealerships,
    isVehicleDealershipsDeleteSuccess,
    isVehicleDealershipsDeleteError,
    savedTableState,
    onTableStateChange,
  } = props;
  const breadcrumbD = [
    { path: "/dashboard", label: "Dashboard" },
    { path: "/vehicle-make", label: "Vehicle Dealerships" },
  ];

  const [isCopy, setIsCopy] = useState(false);
  const [isPrintError, setIsPrintError] = useState(false);
  const [areFiltersVisible, toggleFilterState] = useState(true);
  
  const convertToTSV = (data) => {
    // Get headers from columns (including ID)
    const headers = data.columns.map((item) => item.colLabel).join("\t");

    // Get rows with values in the same order as columns
    const rows = data.rows
      .map((row) => {
        return data.columns
          .map((col) => {
            const value = row[col.dataKey];
            // Handle null/undefined values
            if (value === null || value === undefined) {
              return "-";
            }
            // Convert to string
            return String(value);
          })
          .join("\t");
      })
      .join("\n");

    return `${headers}\n${rows}`;
  };

  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => {
        console.error("Copy failed:", err);
        setIsCopy(false);
      });
  };
  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);
  
  useEffect(() => {
    if (isPrintError) {
      const timer = setTimeout(() => setIsPrintError(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isPrintError]);
  
  const handlePrint = () => {
    const success = printTableData({
      title: "Vehicle Dealerships",
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
    });
    if (!success) {
      setIsPrintError(true);
    }
  };
  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Vehicle Dealerships</h4>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary shadow-btn`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              {screenPermissions?.create && (
                <Button
                  label={"Create Vehicle Dealerships"}
                  className={` p-button-raised`}
                  style={{ borderRadius: "0px" }}
                  onClick={handleCreateVehicleDealerships}
                />
              )}
            </div>
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={exportVehicleDealerships}
              />
              <Button
                label={"Print"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();
  const getInitialFilters = () => {
    const defaultFilters = {
      global: { value: null },
      name: { value: null, filterKey: "name" },
      contactPerson: { value: null, filterKey: "contactPerson" },
      contactNumber: { value: null, filterKey: "contactNumber" },
      address: { value: null, filterKey: "address" },
      emailId: { value: null, filterKey: "emailId" },
      faxNumber: { value: null, filterKey: "faxNumber" },
      notes: { value: null, filterKey: "notes" },
      status: { value: null, filterKey: "status" },
      crtBy: { value: null, filterKey: "crtBy" },
      crtTime: { value: null, filterKey: "crtTime" },
      modBy: { value: null, filterKey: "modBy" },
      modTime: { value: null, filterKey: "modTime" },
    };

    if (savedTableState?.filters) {
      const savedFilters = savedTableState.filters;
      Object.keys(savedFilters).forEach(key => {
        if (defaultFilters[key]) {
          defaultFilters[key] = { ...defaultFilters[key], ...savedFilters[key] };
        }
      });
    }

    return defaultFilters;
  };

  const filters = getInitialFilters();

  const getToastProps = () => {
    let toastTitle = "";
    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle:
          "Unable to open print window. Please check your popup blocker settings.",
        shouldShowToast: true,
      };
    }
    if (isVehicleDealershipsDeleteSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Vehicle Dealership deleted successfully!",
        shouldShowToast: true,
      };
    }
    if (isVehicleDealershipsDeleteError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle: "Error while deleting Vehicle Dealership!",
        shouldShowToast: true,
      };
    }
    if (isCopy) {
      let toastTitle = "Data copied to clipboard!";
      if (!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      }

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const tableProps = {
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Vehicle Dealerships found.",
    filters,
    loadLazyData: fetchVehicleDealershipss,
    loading: isLoading,
    areFiltersVisible,
    showMoreActions: false,
    sortField: savedTableState?.sortField || 'id',
    initialSortOrder: savedTableState?.sortOrder,
    initialFirst: savedTableState?.first || 0,
    initialRows: savedTableState?.rows || 10,
    onTableStateChange,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    onEditRecord: editVehicleDealershipsRoute,
    onDeleteRecord: deleteVehicleDealerships,
    showViewButton: false,
    showCopyButton: false,
    showDeleteButton: true,
    showEditButton: true,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={vehicleBreadcrumbD} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box id="printable">
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Vehicle Dealerships records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default VehicleDealerships;
